<template>
  <div id="detail">
    <div></div>

    <!--购买按钮-->
    <div class="buy relativeItem whiteB">
      <p class="p1">￥800.00</p>
      <button class="absoluteItem centerY radius3" @click="buy">立即购买</button>
    </div>
  </div>
</template>







<script>
export default {
  name: "detail",
  components: {},
  data() {
    return {
    };
  },
  methods: {


    //下订单购买
    buy(){
      this.$router.push({path:"/shopPay"})
    },
  },
  mounted: function() {
    this.$tool.setTitle("商品详情");
    this.$emit("showOhidden", false, 3);
  }
};
</script>






<style scoped lang="scss">
.buy {
  position: fixed;
  width: 100%;
  padding: 0 .8rem;
  padding-top: 1rem;
  bottom: 0;
  left: 0;
  .p1 {
    color: 14px;
  }
  button {
    color: white;
    right: 0.8rem;
    font-size: 12px;
    padding: 0.4rem 0.7rem;
    background: -webkit-linear-gradient(left, #f6d365, #fda085);
    background: linear-gradient(to right, #f6d365, #fda085);
  }
}
</style>
